module.exports = __webpack_public_path__ + "img/MES7Indice2_sommaire.923e2617.png";